import { render, staticRenderFns } from "./shopify-install-instructions.vue?vue&type=template&id=3c942c4a&scoped=true&"
import script from "./shopify-install-instructions.vue?vue&type=script&lang=js&"
export * from "./shopify-install-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c942c4a",
  null
  
)

export default component.exports